import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { User, Role } from 'app/auth/models';
import { ToastrService } from 'ngx-toastr';
import { LanguageService } from '@core/services/language.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  //public
  public currentUser: Observable<User>;

  //private
  private currentUserSubject: BehaviorSubject<User>;

  /**
   *
   * @param {HttpClient} _http
   * @param {ToastrService} _toastrService
   */
  constructor(private _http: HttpClient, private _toastrService: ToastrService , private lanuage : LanguageService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  // getter: currentUserValue
  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  /**
   *  Confirms if user is admin
   */
  get isAdmin() {
    return this.currentUser && this.currentUserSubject.value.role === Role.Admin;
  }

  /**
   *  Confirms if user is client
   */
  get isClient() {
    return this.currentUser && this.currentUserSubject.value.role === Role.Client;
  }

  /**
   * User login
   *
   * @param email
   * @param password
   * @returns user
   */
login(email: string, password: string) {
  return this._http
    .post<any>(`${environment.apiUrl}/api/admin/login`, { email, password })
    .pipe(
      map(response => {

        // ✅ token موجود مباشرة
        if (response?.status === 'success' && response?.token) {

          // حفظ التوكن
          localStorage.setItem('token', response.token);

          // لو مفيش user object من الـ API احذف السطر ده
          // localStorage.setItem('currentUser', JSON.stringify(response.user));

          console.log('Token saved successfully:', response.token);

          // Toast
          setTimeout(() => {
            this.lanuage.currentLang.subscribe((res: string) => {
              res === 'en'
                ? this._toastrService.success(
                    'You have successfully logged in. Enjoy! 🎉',
                    '👋 Welcome!',
                    { toastClass: 'toast ngx-toastr', closeButton: true }
                  )
                : this._toastrService.success(
                    'تم تسجيل الدخول بنجاح. استمتع! 🎉',
                    '👋 مرحبا!',
                    {
                      toastClass: 'toast ngx-toastr',
                      closeButton: true,
                      positionClass: 'toast-top-left'
                    }
                  );
            });
          }, 500);
        }

        return response;
      })
    );
}


  setCurrentValue(next) {
    this.currentUserSubject.next(next);
  }
  /**
   * User logout
   *
   */
  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    // notify
    this.currentUserSubject.next(null);
  }
}
